import React from "react";
import "./sectionTitleStyle.scss";

const SectionLargeTitle = ({ title }) => {
  return (
    <div className="section-large-title">
      <h2>{title}</h2>
    </div>
  );
};

export default SectionLargeTitle;
